import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Image } from 'react-bootstrap';
import { Text, Button } from '@radix-ui/themes';
import { ArrowRight } from '@phosphor-icons/react';

export default function NotFound() {

  const navigate = useNavigate();

  return (
    <Row style={{ justifyContent: 'center' }}>
      <Row style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
        <Col xs={9} sm={7} md={5} lg={4} xl={3} style={{ textAlign: 'center' }}>
          <Image src="/assets/notfound.png" alt="Survey not found" style={{ width: 60, height: 60 }} />
          {/* <Text size="6" as="div" weight="bold">Oops!</Text> */}
          <Text size="3" as="div" style={{ marginTop: 30 }}>The survey page you are looking for either doesn't exist or has been deactivated.</Text>
          <Button variant="ghost" style={{ marginTop: 20 }} onClick={() => window.location.href = 'https://voicebridgeai.com'}>Go to our main website <ArrowRight /></Button>
        </Col>
      </Row>
    </Row>
  )

}
